import { useWealthSavingsSectionContent } from './useWealthSavingsSectionContent';
import { parseWealthSavingsApproachContent } from '../utils/wealthSavingsContent';

export const useWealthSavingsApproachContent = () =>
  useWealthSavingsSectionContent(parseWealthSavingsApproachContent);
